/* eslint-disable */
// eslint-disable-next-line import/prefer-default-export
export const data = {
    /// ////////////////////////////////////////////////////////////
    /// /////////////// Interrupt //////////////////////////////////
    /// ////////////////////////////////////////////////////////////
    Interrupt_header: <h4>Процесс входа в родительский портал EngagED (Внутренний/Внешний)</h4>,
    Interrupt_p0: (
        <h5>
            Для входа вы{" "}
            <strong>
                <u>НЕ</u>
            </strong>{" "}
            будете использовать свою личную электронную почту.
        </h5>
    ),
    Interrupt_p1: (
        <>
            Для входа вам нужно будет ввести адрес электронной почты, состоящий из вашего
            <strong>
                <u>имени пользователя</u>
            </strong>
            , за которым следует{" "}
            <strong>
                <u>@p.dcsdk12.org</u>
            </strong>{" "}
            на следующем экране входа.
            <br />
            Например: если ваше <b>имя пользователя</b> — <b>jsmith</b>, вы введете{" "}
            <strong>
                <u>jsmith@p.dcsdk12.org</u>
            </strong>
            .
            <br />
            <br />
            Ваш пароль совпадает с тем, который вы используете для доступа к Infinite Campus (для текущих родителей) или
            с паролем, который вы создали во время настройки учетной записи для Открытой регистрации (для внешних
            родителей).
        </>
    ),
    Interrupt_p2: (
        <strong>
            Если вам нужна помощь с именем пользователя или паролем, пожалуйста, перейдите на{" "}
            <a href="https://password.dcsdk12.org" target="_blank">
                password.dcsdk12.org
            </a>
            .
        </strong>
    ),
    Interrupt_p3: (
        <>
            <b>Если вы не можете войти после выполнения вышеуказанных шагов, пожалуйста, свяжитесь с нами:</b>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                Техническая поддержка для родителей - английский
            </a>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT@LFLT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                Техническая поддержка для родителей - испанский
            </a>
            <br />
            <a
                href="https://www.k12insight.com/Lets-Talk/embed.aspx?L=PRXB26D5K3LT@LRLT"
                rel="noreferrer"
                style={{ color: "blue" }}
                target="_blank"
            >
                Техническая поддержка для родителей - китайский
            </a>
            <br />
            Центр IT-поддержки: <b>303.387.0001</b>
        </>
    ),
    Interrupt_note:
        "ПРИМЕЧАНИЕ: Сотрудники округа, которые в настоящее время являются родителями, должны следовать приведенным выше инструкциям, используя окно браузера в режиме инкогнито или приватный режим и/или другой браузер.",
    Interrupt_submit: "Перейти к входу",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Header //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Main_Nav_Welcome: "Добро пожаловать,",
    Main_Nav_HelpfulLinks: "Полезные ссылки",
    Main_Nav_LogOut: "Выйти",
    Main_Nav_HelpfulLinks_LI_s1: "Связаться с медсестрой моего(-их) ученика(-ов)",
    Main_Nav_HelpfulLinks_LI_s2: "Академические календари",
    Main_Nav_HelpfulLinks_LI_s3: "Ресурсы для родителей",
    Main_Nav_HelpfulLinks_LI_s4: "Маршруты автобусов",
    Main_Nav_HelpfulLinks_LI_s5: "Онлайн-платежи",
    Main_Nav_HelpfulLinks_LI_s6: "Меню обедов",
    Main_Nav_Exit: "Выход",
    Global_Dashboard: "Панель управления",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Breadcrumb //////////////////////////////
    /// /////////////////////////////////////////////////////////
    Breadcrumb: "Панель управления опекуна DCSD",
    Breadcrumb_Back: "Портал для родителей DCSD Engaged",
    Breadcrumb_EPR: "Архивная информация об EPR DCSD",
    Breadcrumb_Translations: "Переводы экспериментальные",
    Breadcrumb_School_Selection: "Выбор школы",
    Breadcrumb_New_Student_Create: "Создание нового студента",
    Breadcrumb_Schools_Making_Offers: "Школы готовят предложения",
    /// /////////////////////////////////////////////////////////
    /// /////////////// OE //////////////////////////////////////
    /// /////////////////////////////////////////////////////////
    OE_Closed_Title: "Окно открытой регистрации закрыто",
    OE_Closed_Text:
        "Окно открытой регистрации сейчас закрыто. Пожалуйста, вернитесь в периоды доступа для родителей, установленные округом. Спасибо.",
    OE_Student_Info_Breadcrumb: "Информация об учащемся и опекуне",
    OE_Student_Info_Guardian_Title: "Текущая информация об опекуне",
    OE_Student_Info_Student_Title: "Текущая информация об ученике",
    OE_Student_Info_Email: "Электронная почта",
    OE_Student_Info_Address: "Адрес",
    OE_Student_Info_Phone: "Телефон",
    OE_Student_Info_Current_School: "Текущая школа",
    OE_Student_Info_Neighborhood_School: "Районная школа",
    OE_Student_Info_Scheduled_School: "Запланированная школа на следующий год",
    OE_New_Student: "Новый ученик",
    OE_Unavailable: "Недоступно",
    OE_Form_FirstName: "Официальное имя ученика",
    OE_Form_FirstName_Description: "Используйте официальное имя ученика из свидетельства о рождении",
    OE_Form_MiddleName: "Официальное второе имя ученика",
    OE_Form_MiddleName_Description: "Используйте официальное второе имя ученика из свидетельства о рождении",
    OE_Form_LastName: "Официальная фамилия ученика",
    OE_Form_LastName_Description: "Используйте официальную фамилию ученика из свидетельства о рождении",
    OE_Form_Gender: "Пол",
    OE_Form_Gender_Male: "Мужской",
    OE_Form_Gender_Female: "Женский",
    OE_Form_Gender_NonBinary: "Небинарный",
    OE_Form_Birthdate: "Дата рождения ученика",
    OE_Form_Month: "Месяц",
    OE_Form_Example: "Пример",
    OE_Form_Day: "День",
    OE_Form_Year: "Год",
    OE_Form_Clear_Birthdate: "Очистить поля даты рождения",
    OE_Form_Student_Address: "Официальный адрес ученика",
    OE_Form_Student_Address_Description:
        "Если вы проживаете в округе Дуглас (Douglas) или Элберт (Elbert), пожалуйста, начните вводить свой адрес и выберите его из списка рекомендуемых адресов.",
    OE_Form_Search_Address: "Поиск адреса",
    OE_Form_Apt_Or_Unit: "номер квартиры или блока",
    OE_Form_Select: "Выбрать",
    OE_Form_Address1: "Адрес (строка 1)",
    OE_Form_Address2: "Адрес (строка 2)",
    OE_Form_City: "Город",
    OE_Form_State: "Штат",
    OE_Form_Zip: "Почтовый индекс",
    OE_Form_App_For_Grade: "Заявка на открытую регистрацию в класс",
    OE_Form_App_For_Grade_Description1: "Исходя из возраста вашего ученика в", // [some variable school year range]
    OE_Form_App_For_Grade_Description2: "учебном году",
    OE_Form_App_For_Grade_Description3: (
        <>
            вы подаете заявку на открытую регистрацию в класс, указанный в{" "}
            <span className="yellow-box">желтом поле</span> ниже. Если "Класс для поступления" указан неверно,
            пожалуйста, свяжитесь с нашим Отделом программ по выбору (Choice Programming Department) по адресу{" "}
            <span className="bold">open-enrollmentusergroup@dcsdk12.org</span>, чтобы обсудить ваши конкретные
            обстоятельства.{" "}
            <span className="will-be">
                Если "Класс для поступления" указан неверно, <span className="bold">и</span> вы продолжите выбор школ,
                ваш запрос на открытую регистрацию может быть аннулирован.
            </span>
        </>
    ),
    OE_Form_Current_Grade: "Текущий класс",
    OE_Form_Applying_For_Grade: "Класс для поступления",
    OE_Form_Applying_For_Kindergarten:
        "Ученик будет подавать заявку на открытую регистрацию в детский сад (Kindergarten) на следующий учебный год",
    OE_Form_Applying_For_Kinder_Title: "Подача заявки в детский сад",
    OE_Form_Applying_For_Kinder_Body:
        'Пожалуйста, подтвердите, что вы хотите изменить "Класс для поступления" ученика с 1-го класса на детский сад. Если вы вносите это изменение после выбора школ, эти выбранные школы будут удалены, и вам нужно будет сделать выбор заново.',
    OE_Form_Reasons_For_Leaving: "Причины ухода",
    OE_Form_Important: "Важно",
    OE_Form_Important_Note: "Примечание: Необходимо выбрать одну или несколько причин",
    OE_Form_Important_Reasons: "Каковы причины ухода из", // [some variable school name]
    OE_Form_Important_Other:
        'Примечание: Если вы выберете "Другое" в качестве причины подачи заявки, вы должны оставить комментарий, чтобы отправить свой выбор школы.',
    OE_Form_Address_Placeholder: "Начните вводить адрес здесь",
    OE_Buttons_Delete: "Удалить открытую регистрацию",
    OE_Buttons_Back_To_Dashboard: "Вернуться на панель управления",
    OE_Buttons_Confirm_And_Proceed: "Подтвердить и продолжить",
    OE_Buttons_Cancel: "Отмена",
    OE_Buttons_Email: "Сохранить и отправить мне мой выбор",
    OE_Dialog_Delete_Title: "Подтверждение удаления открытой регистрации",
    OE_Dialog_Delete_Body1: "Пожалуйста, подтвердите, что вы хотите удалить заявку на открытую регистрацию для ученика", // [some variable student name]
    OE_Dialog_Delete_Body2:
        "Это действие удалит все связанные данные о выборе школы по открытой регистрации для этого ученика.",
    OE_Dialog_Back_Title1: "Данные открытой регистрации не сохранены",
    OE_Dialog_Back_Title2: "Перейти в личный кабинет опекуна",
    OE_Dialog_Back_Body1: "Заявление на открытую регистрацию еще не сохранено для учащегося",
    OE_Dialog_Back_Body2: "Вы потеряете текущий прогресс, если решите вернуться в личный кабинет родителя.",
    OE_Dialog_Back_Body1a: "Заявление на открытую регистрацию для вашего учащегося еще не сохранено.",
    OE_Schools_Title: "Школы-участницы по регионам (выберите до 4 школ)",
    OE_Schools_Body:
        "Пожалуйста, выберите регион, чтобы увидеть список школ, доступных для открытого зачисления. Вы должны выбрать как минимум одну (1) школу и можете выбрать не более четырех (4) школ.",
    OE_Schools_Current_Address: "Текущий адрес",
    OE_Schools_Selected: "выбрано",

    OE_Schools_My_Schools_Title: "Мои выбранные школы",
    OE_Schools_My_Schools_Body:
        "Это школы, которые вы выбрали для открытого зачисления. Для каждой выбранной школы вы должны нажать кнопку «Выбрать причины», чтобы сообщить нам, что привлекло вас подать заявление на открытое зачисление в эту школу. Обратите внимание, что вы не сможете сохранить/отправить по электронной почте свой выбор школ, пока не укажете хотя бы одну причину подачи заявления для каждой выбранной школы. Чтобы удалить выбранную школу, нажмите на значок корзины в правом верхнем углу карточки школы.",
    OE_Schools_My_Schools_Grade: "Подача заявления в класс",
    OE_Schools_My_Schools_Status: "Статус",
    OE_Schools_My_Schools_Select_Reasons: "Выбрать причины",
    OE_Schools_My_Schools_Reasons_Title: "Причины подачи заявления",
    OE_Schools_Selected_Schools_Header: "Это школы, которые вы выбрали для открытого зачисления",
    OE_Schools_Selected_Schools_Body: (
        <>
            <h6>
                Вы <u>получили предложения</u> от следующих школ:
            </h6>
            <span>
                Вы можете принять предложение от одной школы. Все остальные предложения будут автоматически отклонены.
                Вы также можете отклонить любые/все предложения.
            </span>
        </>
    ),
    OE_Schools_Selected_Schools_Body_2: (
        <>
            <h6>
                Вы будете включены в <u>список ожидания</u> следующих школ:
            </h6>
            <span>
                Во время второго раунда процесса открытого зачисления эти школы могут связаться с вами напрямую, чтобы
                предложить место для зачисления.
            </span>
        </>
    ),
    OE_Schools_Selected_Schools_None: "На данный момент у вашего ученика нет выбранных школ",
    OE_Schools_My_Schools_Reasons_Body: (
        <p>
            Пожалуйста, укажите{" "}
            <u>
                <strong>хотя бы одну</strong>
            </u>{" "}
            причину подачи заявления на открытое зачисление в эту школу. Вы можете выбрать все подходящие варианты и
            изменить их в любое время в течение периода подачи заявлений.
        </p>
    ),
    OE_Schools_My_Schools_Note:
        "Примечание: Если вы выберете «Другое» в качестве причины подачи заявления, вы должны ввести комментарий, чтобы отправить свой выбор школы.",
    OE_Schools_My_Schools_Comment: "Пожалуйста, введите комментарий",

    OE_Toast_Email_Error: "Не удалось отправить подтверждение опекуну по электронной почте.",
    OE_Toast_IC_Error: "Возникла проблема при получении данных ученика из IC.",
    OE_Toast_Email: "Подтверждение выбора школы для открытого зачисления отправлено на ",
    OE_Toast_Email_Failure:
        "Не удалось отправить подтверждение выбора школы, так как отсутствует действующий адрес электронной почты опекуна.",
    OE_Toast_Deleted:
        "Заявка на открытое зачисление для ученика успешно удалена. Перенаправление в родительскую панель.",
    OE_Toast_Saved: "Выбор школ успешно сохранен. Перенаправление в родительскую панель.",
    OE_Toast_Offer_Saved: "Принятие и/или отклонение предложения о выборе школы успешно сохранено.",
    OE_Toast_Saved_Emailed:
        "Принятие и/или отклонение предложения о выборе школы успешно сохранено. Перенаправление в родительскую панель.",
    OE_Toast_Update_Error: "Произошла ошибка при обновлении вашего выбора школ.",
    OE_Toast_Delete_Error: "Не удалось удалить открытое зачисление ученика.",
    OE_Toast_Student_Updated: "Информация об ученика для открытого зачисления успешно обновлена.",
    OE_Toast_Data_Error:
        "Произошла ошибка при загрузке ваших данных. Пожалуйста, перезагрузите страницу и попробуйте снова.",
    OE_Toast_Valid_Birthdate: "Пожалуйста, введите корректную дату рождения ученика (ММ-ДД-ГГГГ).",
    OE_Toast_Student_Added: "Ученик успешно добавлен для открытого зачисления.",
    OE_Toast_OE_Error: "Не удалось удалить открытое зачисление ученика.",
    OE_Toast_OE_Saved: "Информация об ученике для открытого зачисления успешно сохранена.",
    OE_Toast_Student_Updated_2: "Информация об ученике успешно обновлена.",
    OE_Toast_Region_Error: "Возникла проблема при получении данных о школах региона",
    OE_Toast_Student_Error: "Возникла проблема при получении данных ученика",
    OE_Toast_Reasons_Error: "Возникла проблема при получении причин подачи заявления",
    OE_Toast_School_Choice_Success: "Принятие и/или отклонение предложения о выборе школы успешно сохранено.",
    OE_Toast_Redirecting: "Перенаправление в родительскую панель",

    OE_Dialog_Window_Closed_Title: "Период открытого зачисления закрыт",
    OE_Dialog_Window_Closed_Body:
        "Период открытого зачисления сейчас закрыт. Пожалуйста, вернитесь в периоды доступа для родителей, установленные округом. Спасибо.",
    OE_Dialog_Access_Denied_Title: "Доступ запрещен",
    OE_Dialog_Access_Denied_Body:
        "Извините, но у вас нет прав на просмотр данных этого ученика. Пожалуйста, вернитесь в родительскую панель.",
    OE_Dialog_Ineligible_Title: "Дата рождения не соответствует требованиям",
    OE_Dialog_Ineligible_Body:
        "Судя по дате рождения ученика, его возраст находится вне диапазона для открытого зачисления. Пожалуйста, свяжитесь с отделом программ по выбору (Choice Programming department), чтобы обсудить конкретные обстоятельства и/или варианты открытого зачисления.",
    OE_Dialog_Processing: "Обработка… Пожалуйста, подождите",
    OE_Modal_Ineligible: (
        <p>
            Исходя из введенной вами даты рождения,{" "}
            <span className="age">возраст ученика находится вне диапазона для открытого зачисления</span>. Пожалуйста,
            свяжитесь с отделом программ по выбору (Choice Programming department), чтобы обсудить конкретные
            обстоятельства и/или варианты открытого зачисления.
        </p>
    ),

    OE_Dialog_Incorrect_Info_Title: "Неверная информация об ученике",
    OE_Dialog_Incorrect_Info_Body_1: "Нам жаль, что обнаружена ошибка в информации об ученике: ", // [variable student name]
    OE_Dialog_Incorrect_Info_Body_2: (
        <>
            <div className="top-sentence">
                Пожалуйста, выполните следующие действия, прежде чем подавать заявление на открытое зачисление...{" "}
            </div>
            <div className="number-container">
                <div className="number">1</div>
                <div className="instruction">
                    Пожалуйста, свяжитесь со школой вашего ученика, чтобы запросить исправление данных. Школа может
                    обработать этот запрос немедленно, или это может занять некоторое время. Спасибо за ваше терпение.
                </div>
            </div>
            <div className="number-container">
                <div className="number">2</div>
                <div className="instruction">
                    Как только вы получите подтверждение от школы о том, что исправление данных завершено, пожалуйста,
                    вернитесь, чтобы начать подачу заявления. У вас будет возможность подтвердить правильность
                    обновленной информации об ученике.
                </div>
            </div>
            <div className="number-container">
                <div className="number">3</div>
                <div className="instruction">
                    Как только вы подтвердите точность информации, вы сможете продолжить оформление заявления на
                    открытое зачисление.
                </div>
            </div>
        </>
    ),

    OE_Buttons_Student_Info_Good: "Информация об ученике верна",
    OE_Buttons_Student_Info_Incorrect: "Информация об ученике неверна",
    OE_Buttons_Save_Changes: "Сохранить изменения",
    OE_Buttons_Continue: "Продолжить",
    OE_Buttons_Submit: "Отправить",
    OE_Buttons_Accept: "Принять",
    OE_Buttons_Decline: "Отклонить",
    OE_Buttons_Delete: "Удалить",
    OE_Buttons_Save: "Сохранить",

    OE_Dialog_Choices_Will_Delete_Title: "Предыдущий выбор школ будет удален",
    OE_Dialog_Choices_Will_Delete_Body: (
        <p>
            Изменение домашнего адреса этого ученика могло привести к изменению списка школ, доступных для открытого
            зачисления. В результате предыдущий выбор школ будет удален, и вам нужно будет заново выбрать интересующие
            вас школы после сохранения изменений. Пожалуйста, подтвердите, что вы хотите продолжить, ИЛИ нажмите
            «Отмена» и свяжитесь с командой по программам выбора (Choice Programming team) по адресу{" "}
            <span className="bold">open-enrollmentusergroup@dcsdk12.org</span> для обсуждения дальнейших действий.
        </p>
    ),
    OE_Dialog_Birthdate_Change_Body: (
        <p>
            Изменение даты рождения этого ученика привело к изменению класса для подачи заявления на открытое
            зачисление. В результате вам нужно будет заново выбрать интересующие вас школы после сохранения изменений.
            Пожалуйста, подтвердите, что вы хотите продолжить.
        </p>
    ),

    OE_Buttons_Accept_Proceed: "Принять и продолжить",
    OE_Buttons_Should_Not_Match: "Имена не должны совпадать",
    OE_Modal_Names_Match_Title: "Предупреждение о совпадении имен ученика и опекуна",
    OE_Modal_Names_Match_Body_1:
        "Имя и фамилия, которые вы ввели для ученика, совпадают с именем и фамилией, связанными с вашей учетной записью опекуна.",
    OE_Modal_Names_Match_Body_2: "Введенное имя ученика:",
    OE_Modal_Names_Match_Body_3: "Имя учетной записи опекуна:",
    OE_Modal_Names_Match_Note: "Примечание: регистр символов не учитывается",
    OE_Modal_Names_Correction_Title: "Исправление совпадающих имен",
    OE_Modal_Names_Correction_Body: (
        <>
            <div>
                Вы указали, что созданная вами внешняя учетная запись опекуна использует имя и фамилию вашего ученика
                вместо ваших собственных. Прежде чем продолжить открытое зачисление, пожалуйста, свяжитесь с центром
                ИТ-поддержки по телефону{" "}
                <strong>
                    <u>303-387-0001</u>
                </strong>{" "}
                , чтобы исправить информацию вашей учетной записи.
            </div>
            <br />
            <div>
                <u>
                    Обратите внимание: введенная вами информация об ученике не будет сохранена, и ее нужно будет ввести
                    заново после исправления информации вашей учетной записи.
                </u>
            </div>
        </>
    ),
    OE_Next_Steps: "Дальнейшие действия",
    OE_Important_Parent_Info: "Важная информация для родителей",
    OE_Next_Steps_1: "Школы DCSD направили предложения по всем заявкам первого раунда. Пожалуйста, обратите внимание, что вы могли получить или не получить предложение о зачислении от выбранных вами школ. Учтите, что в течение этого периода рассмотрения вы можете принять только одно предложение о зачислении.",
    OE_Next_Steps_2: "В настоящее время школы DCSD рассматривают принятые родителями предложения.",
    OE_Next_Steps_Post: "После принятия предложения школа свяжется с вами напрямую для обсуждения дальнейших действий в процессе зачисления. Вам не нужно связываться со школой, так как это может замедлить процесс."
};
/* eslint-enable */
